import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MifClientTokenStorageService {
  private accessToken: string | null = null;

  public getToken(): string | null {
    return this.accessToken;
  }

  public saveToken(token: string): void {
    this.accessToken = token;
  }

  public clearToken(): void {
    this.accessToken = null;
  }
}
